import HeaderHome from "../components/HeaderHome";
import SiteFooter from "../components/SiteFooter";
import { WHATSAPP_URL } from "../constants";

export default function AboutPage() {
  return (
    <div className="site-root">
      <HeaderHome />

      <main className="page-main">
        <div className="container prose">

          <h1>About FreshClayPot</h1>

          <p className="updated">
            Traditional cow curd — thick, natural, and made the way your grandmother would recognise.
          </p>

          {/* INTRO */}
          <p>
            At FreshClayPot, we believe curd should taste like it comes straight from the farm — not from a factory.
            That’s why we source fresh cow milk directly from local farmers and follow traditional methods to prepare
            every batch with care.
          </p>

          <p>
            We use gentle heating, natural cultures, and slow fermentation in real clay pots to create curd that is
            rich, thick, and full of authentic flavor — with absolutely no chemicals or preservatives.
          </p>

          {/* WHY CLAY */}
          <h2>Why Clay Pots?</h2>

          <p>
            Clay pots are not just traditional — they make a real difference. Unglazed terracotta allows natural air
            flow, maintains the right temperature, and enhances fermentation.
          </p>

          <p>
            The result? Curd that is:
          </p>

          <ul>
            <li>✔ Thicker and creamier texture</li>
            <li>✔ Naturally enhanced taste</li>
            <li>✔ Better cooling and freshness</li>
          </ul>

          {/* WHY CHOOSE US */}
          <h2>Why Choose FreshClayPot?</h2>

          <ul>
            <li>🐄 Farm-fresh cow milk</li>
            <li>🏺 Traditional clay pot preparation</li>
            <li>🌿 No chemicals or preservatives</li>
            <li>📦 Freshly packed daily</li>
            <li>🚚 Flexible delivery (Daily / Alternate / Weekly)</li>
          </ul>

          {/* QUALITY */}
          <h2>Quality & Care</h2>

          <p>
            Every batch is prepared with strict hygiene and consistency. We produce in small batches to ensure
            freshness and maintain the highest quality standards — this is not mass-produced curd.
          </p>

          {/* DELIVERY */}
          <h2>Delivery</h2>

          <p>
            We offer flexible delivery options based on your needs — daily delivery, alternate days, or selected weekly
            schedules. Fresh curd delivered right to your doorstep.
          </p>

          {/* CONTACT */}
          <h2>Contact Us</h2>

          <p>
            Have questions or want to place an order?
          </p>

          <p>
            👉 Message us directly on WhatsApp:{" "}
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
              +91 8688307782
            </a>
          </p>

          <p>
            We usually respond quickly and help you set up your delivery easily.
          </p>

        </div>
      </main>

      <SiteFooter secondaryTo="/" secondaryLabel="Home" />
    </div>
  );
}